import createEntryListsPdf from './createEntryListsPdf';
import { createAthleteRecord } from '../common';
import DownloadsPicker from '../DownloadsPicker';
import FileDownload from '../../../components/FileDownload';

import React from 'react';
import {
  filter,
  find,
  flatMap,
  mapValues,
  orderBy,
  repeat,
  sortBy,
  times,
  uniqBy,
} from 'lodash';

// TODO: Iterate contests, to show "no entries" text?
// TODO: Support modifedAt metadata!
const createEntryLists = (entries, mode) => {
  switch (mode) {
    case 'template':
      return [
        {
          title: repeat('_', 30),
          athletes: times(30, i => ({ sequenceNumber: i + 1 })),
        },
      ];
    default:
      // FIXME: Entry ordering is sketchy!
      const contests = uniqBy(flatMap(entries, 'contests'), 'id');
      return flatMap(sortBy(contests, ['order']), contest => {
        const { ageGroup, bodyweightCategory } = contest;
        const athletes = orderBy(
          filter(entries, entry => find(entry.contests, { id: contest.id })),
          ['referenceTotal', 'name'],
          ['desc', 'asc'],
        ).map(createAthleteRecord);
        return {
          title: `${ageGroup.title} ${bodyweightCategory.title}`,
          athletes,
          metadata: {
            modifiedAt: '???',
          },
        };
      });
  }
};

const EntryListsDownload = ({ entries, mode, meta, ...props }) => {
  const onFileContents = () => {
    return createEntryListsPdf(createEntryLists(entries, mode), meta);
  };
  return (
    <FileDownload
      mimeType="appication/pdf"
      fileName={`entry-lists-${mode}.pdf`}
      onContents={onFileContents}
      {...props}
    />
  );
};

const EntryListsDownloads = ({ entries, meta }) => {
  const modes = mapValues(
    {
      all: 'All lists',
      template: 'Empty template',
      //...(process.env.NODE_ENV !== 'production' ? { test: 'Test list' } : {}),
    },
    (text, mode) => ({
      mode,
      text,
      download: (
        <EntryListsDownload mode={mode} entries={entries} meta={meta} />
      ),
    }),
  );

  return <DownloadsPicker modes={modes} />;
};

export default EntryListsDownloads;



// WEBPACK FOOTER //
// ./src/pages/Home/entryLists/EntryListsDownloads.js